import { OriginalRightsDefinitionLoaderFromHTML } from "./OriginalRightsDefinitionLoaderFromHTML";

/**
 * Funkce pro načtení práv z XML definic.
 * - Určeno pro potřeby naplnění {@link IWithOriginalRightsDefinition.originalRightsDefinition}.
 * - Snahou je omezit použití této funkce na minimum. Ideálně jen v Registratoru. A všude jinde pracovat již s {@link IWithOriginalRightsDefinition}.
 * - Pozor: Práva je třeba načíst ještě před instanciací (react) control. Důvod - viz {@link OriginalRightsDefinitionLoaderFromHTML}.
 *
 * @param controlElement HTML element potřebný pro vytvoření a inicializaci control.
 */
export const loadOriginalRightsDefinition = (controlElement: HTMLElement) => OriginalRightsDefinitionLoaderFromHTML.load(controlElement);
